export type TConditonalWrap = {
  children: React.ReactElement;
  condition: boolean;
  wrapper: (children: React.ReactElement) => JSX.Element;
};

const ConditonalWrap: React.FC<TConditonalWrap> = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children

export default ConditonalWrap